import Promise from 'promise';
import { axios, CommonHelper, history } from '../_helpers';

export const TemplateService = {
    createTemplate,
    updateTemplate,
    getAllTemplate,
    getTemplateDetails
};

function createTemplate(params) {
    return new Promise(function (resolve, reject) {
        axios.post('createTemplate', params).then((res) => {
            resolve(res);
        }).catch(error => { 
            reject(error.message);
        });
    });
};

function updateTemplate(params) {
    return new Promise(function (resolve, reject) {
        axios.post('updateTemplate', params).then((res) => {
            resolve(res);
        }).catch(error => { 
            reject(error.message);
        });
    });
};


function getAllTemplate() {
    return new Promise(function (resolve, reject) {
        axios.get('getAllTemplate').then((res) => {
            resolve(res);
        }).catch(error => { 
            reject(error.message);
        });
    });
};

function getTemplateDetails(templateId) {
    return new Promise(function (resolve, reject) {
        axios.get('getTemplateDetails?templateId='+ templateId).then((res) => {
            resolve(res);
        }).catch(error => { 
            reject(error.message);
        });
    });
};


// WEBPACK FOOTER //
// ./src/_services/template.service.js